// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1cRJj","unreadBadge":"styles_unreadBadge__2kRtU","modalContent":"styles_modalContent__2_PzI","modal":"styles_modal__4Wy2-"};